export const IN_PROGRESS = 1;
export const CLOSED = 2;
export const PENDING = 3;
export const INSPECTION_STATUSES = [IN_PROGRESS, PENDING, CLOSED];
